import { forwardRef, ReactNode } from 'react';

import { useGeneralState } from 'app/state/GeneralContext/hooks';

import DialogContent, { DialogContentProps } from './DialogContent';
import Box from '../Box';

interface Props extends DialogContentProps {
  children: ReactNode;
}

const DialogActions = forwardRef<HTMLDivElement, Props>(({
  children,
  ...dialogContentProps
},
ref) => {
  const {
    currentDevice,
  } = useGeneralState();
  const isMobileWidth = currentDevice === 'mobile';

  return (
    <DialogContent
      fullWidth
      ref={ref}
      {...dialogContentProps}
      className="dialog_dialog-actions"
    >
      <Box
        display="flex"
        flexWrap={isMobileWidth ? 'wrap-reverse' : undefined}
        gap={4}
        justifyContent="flex-end"
      >
        {children}
      </Box>
    </DialogContent>
  );
});

export default DialogActions;
